import L from 'leaflet';

const addScaleControl = (leafletMap, position) => {
  const result = L.control.scale({ position: position });
  leafletMap.addControl(result);
  return result;
};

export { addScaleControl };